import { render, staticRenderFns } from "./UsersEdit.vue?vue&type=template&id=2d1680a8&scoped=true"
import script from "./UsersEdit.vue?vue&type=script&lang=js"
export * from "./UsersEdit.vue?vue&type=script&lang=js"
import style0 from "./UsersEdit.vue?vue&type=style&index=0&id=2d1680a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1680a8",
  null
  
)

export default component.exports